import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackRosreestrFlatSaleShow, trackShowMoreClick } from './tracking';
import { CardSectionNew } from '../../components/CardSectionNew';
import { NameValueList } from '../../components/NameValueList';
import { RosreestrItemValue, RosreestrSection } from '../../components/RosreestrFlatSale';
import { selectRosreestrItems } from '../../selectors/rosreestr';

const MAX_PREVIEW_ITEMS = 6;

export function RosreestrFlatSaleContainerNew() {
  const items = useSelector(selectRosreestrItems);
  const [isShown, setIsShown] = React.useState(items.length <= MAX_PREVIEW_ITEMS);
  const shownItems = React.useMemo(() => (isShown ? items : items.slice(0, MAX_PREVIEW_ITEMS)), [isShown, items]);
  const leftCol = React.useMemo(() => shownItems.filter((_, i) => i % 2 === 0), [shownItems]);
  const rightCol = React.useMemo(() => shownItems.filter((_, i) => i % 2 !== 0), [shownItems]);

  const handleShowMoreClick = React.useCallback(() => {
    trackShowMoreClick();
    setIsShown(true);
  }, []);

  if (items.length === 0) {
    return null;
  }

  return (
    <ActionAfterViewed callback={trackRosreestrFlatSaleShow}>
      <CardSectionNew>
        <RosreestrSection isRedesign hasShowMoreButton={!isShown} onShowMoreClick={handleShowMoreClick}>
          <NameValueList.Section columns={2}>
            <NameValueList>
              {leftCol.map(({ title, properties }) => (
                <NameValueList.Item
                  key={title}
                  name={title}
                  value={<RosreestrItemValue alignRight items={properties} />}
                />
              ))}
            </NameValueList>
            <NameValueList>
              {rightCol.map(({ title, properties }) => (
                <NameValueList.Item
                  key={title}
                  name={title}
                  value={<RosreestrItemValue alignRight items={properties} />}
                />
              ))}
            </NameValueList>
          </NameValueList.Section>
        </RosreestrSection>
      </CardSectionNew>
    </ActionAfterViewed>
  );
}
